import { useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { Download, QrCode, Check, Copy } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';

export function QRCodeModal({ open, onClose, galleryName, url, title }) {
  const displayUrl = url || window.location.href;
  const displayTitle = title || galleryName || 'Gallery';
  const [copied, setCopied] = useState(false);

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(displayUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (e) { /* noop */ }
  };

  const handleDownloadQR = () => {
    const svg = document.getElementById('gallery-qr-code');
    if (!svg) return;
    const svgData = new XMLSerializer().serializeToString(svg);
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const img = new Image();
    img.onload = () => {
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, 0, 0);
      const pngUrl = canvas.toDataURL('image/png');
      const a = document.createElement('a');
      a.href = pngUrl;
      a.download = `${displayTitle}-qr-code.png`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    };
    img.src = 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(svgData)));
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md font-tiq-body" style={{ background: '#fff', borderRadius: 14 }}>
        <DialogHeader>
          <DialogTitle className="font-tiq-display uppercase flex items-center gap-2" style={{ color: '#141414', fontWeight: 800, letterSpacing: '-0.015em' }}>
            <QrCode className="w-5 h-5 text-[#BF212F]" />
            {displayTitle}
          </DialogTitle>
        </DialogHeader>

        <div className="flex flex-col items-center space-y-4 p-2">
          <div style={{ background: '#fff', padding: 16, borderRadius: 14, border: '1px solid #E2DED6' }}>
            <QRCodeSVG
              id="gallery-qr-code"
              value={displayUrl}
              size={200}
              level="H"
              includeMargin
              fgColor="#141414"
              bgColor="#ffffff"
              imageSettings={{ src: '/turbo-icon.png', height: 40, width: 40, excavate: true }}
            />
          </div>

          <p className="text-center text-sm" style={{ color: '#55555C' }}>
            Scan to open the gallery on your phone
          </p>

          {/* copy-link row */}
          <div className="w-full flex items-center gap-2" style={{ background: '#F4F2EE', border: '1px solid #E2DED6', borderRadius: 10, padding: '8px 8px 8px 12px' }}>
            <span className="font-tiq-mono flex-1 truncate" style={{ fontSize: 12, color: '#55555C', minWidth: 0 }}>{displayUrl}</span>
            <button onClick={copyLink} className="font-tiq-heading inline-flex items-center gap-1.5 text-white flex-shrink-0" style={{ background: '#BF212F', borderRadius: 8, padding: '8px 12px', fontWeight: 600, fontSize: 12.5, cursor: 'pointer' }}>
              {copied ? <><Check className="w-3.5 h-3.5" /> Copied</> : <><Copy className="w-3.5 h-3.5" /> Copy</>}
            </button>
          </div>

          <div className="flex gap-2 w-full">
            <button onClick={handleDownloadQR} className="font-tiq-heading flex-1 inline-flex items-center justify-center gap-2 text-white" style={{ background: '#141414', borderRadius: 10, padding: '11px 14px', fontWeight: 600, fontSize: 13, cursor: 'pointer' }}>
              <Download className="w-4 h-4" /> Download QR
            </button>
            <button onClick={onClose} className="font-tiq-heading flex-1" style={{ border: '1px solid #E2DED6', color: '#55555C', borderRadius: 10, padding: '11px 14px', fontWeight: 600, fontSize: 13, cursor: 'pointer', background: '#fff' }}>
              Close
            </button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default QRCodeModal;
